import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { DashboardService } from 'src/app/modules/service/dashboard.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-reset-Password',
  templateUrl: './reset-Password.component.html',
  styleUrls: ['./reset-Password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  constructor(public service: DashboardService, public dialogRef: MatDialogRef<ResetPasswordComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,private router: Router,private _snackBar: MatSnackBar) {



  }

  ngOnInit() {
    this.appuser=JSON.parse(localStorage.getItem('userdata'));

    this.payload.email=this.appuser.email;
  }

  accountType=[
    {name:'Customer',value:'client'},
    {name:'Intermediary',value:'agent'},
  ]

  step=1;
  appuser: any
  confirm_new_Password:""
  hasError=false;
  questions:any;
  payload: any={
    email:'',
    answer1:'',
    answer2:'',
    answer3:'',
  }

  onSubmit=()=>{
    this.hasError=false;
    if(this.step==1){
        if(this.payload.email==''){
          this.hasError=true;
          (Swal as any).fire({
            title: 'Validation Alert',
            text: 'Kindly complete the highlighted fields',
            icon: 'warning',
            confirmButtonText: 'Ok',
            cancelButtonText: 'Cancel'
          })
        }
        else
        {
           this.service.resetPassword({email:this.payload.email})
           .toPromise()
           .then((response:any)=>{
               if(response.responseCode=='000'){
                  (Swal as any).fire({
                    title: 'Successful',
                    text: `A one time Password (OTP) has been mailed to you (${this.payload.email})`,
                    icon: 'success',
                  });

                  setTimeout(()=>{
                    this.dialogRef.close();
                  },10000);
              }
              else if(response.hasOwnProperty('responseMessage'))
                (Swal as any).fire({
                  title: 'Failed',
                  text: response.responseMessage,
                  icon: 'error',
                });
              else
                (Swal as any).fire({
                  title: 'Failed',
                  text: 'Reset Password Failed!',
                  icon: 'error',
                });
           })
           .catch(error=>{
              (Swal as any).fire({
                title: 'Failed',
                text: 'Password Reset Failed!',
                icon: 'error',
              });
           })
        }
      }

      // else if(this.step==1){
      //   if(this.payload.email==''){
      //     this.hasError=true;
      //     (Swal as any).fire({
      //       title: 'Validation Alert',
      //       text: 'Kindly complete the highlighted fields',
      //       icon: 'warning',
      //       confirmButtonText: 'Ok',
      //       cancelButtonText: 'Cancel'
      //     })
      //   }
      //   else{
      //     Swal.showLoading();;
      //     this.service.resetPasswordRequest({email:this.payload.email})
      //   .toPromise()
      //   .then((response: any)=>{
      //       if(response.hasOwnProperty('responseCode') && response.responseCode=='000'){
      //         this.questions=(response.hasOwnProperty('profile') && response.profile.length) ? response.profile[0]:null;
      //         this.payload.code=response.code;
      //         if(this.questions){
      //           Swal.close();
      //           this.step=2;
      //         }
      //       }
      //       else if(response.hasOwnProperty('responseCode') && response.responseCode=='W1012'){
      //         (Swal as any).fire({
      //           title: 'Failed',
      //           text: 'Wrong Email!',
      //           icon: 'warning',
      //         });
      //       }
      //       else if(response.hasOwnProperty('responseCode') && response.responseCode=='098'){
      //         (Swal as any).fire({
      //           title: 'Failed',
      //           text: 'Invalid Email!',
      //           icon: 'warning',
      //         });
      //       }
      //       else
      //       (Swal as any).fire({
      //         title: 'Failed',
      //         text: 'Reset Password Failed!',
      //         icon: 'error',
      //       });
      //   }).catch(error=>{
      //     (Swal as any).fire({
      //       title: 'Failed',
      //       text: 'Password Reset Failed!',
      //       icon: 'error',
      //     });
      //    })
      //   }
      // }

  }


  //trigger the snackbar
  alertSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  onPasswordInput=(evt)=>{
    isNaN(+`${evt.target.value}`)
     if(isNaN(+`${evt.target.value}`))
     evt.target.value='';
  }
}
